import { IPluginMetadataSucceededResult } from 'app/apis/plugin-metadata-api.service';
import { format } from 'app/shared/utils/string.util';

const connector: IPluginMetadataSucceededResult = {
    connectorName: 'Kafka',
    dataType: 'Hierarchical',
    SupportEncryption: true,
    connectionSettings: [
        {
            type: 'String',
            name: 'kafkaBroker',
            required: true,
            sensitive: false,
            signature: false
        },
        {
            type: 'String',
            name: 'username',
            required: true,
            sensitive: false,
            signature: false
        },
        {
            type: 'String',
            name: 'password',
            required: true,
            sensitive: true,
            signature: false
        }
    ],
    readSettings: [
        {
            type: 'String',
            name: 'topic',
            required: true
        },
        {
            type: 'String',
            name: 'schemaRegistry',
            required: true
        },
        {
            type: 'Boolean',
            name: 'dataDump'
        },
        {
            type: 'String',
            name: 'startingOffset',
            required: true
        },
        {
            type: 'Integer',
            name: 'jobDuration',
            required: true
        }
    ],
    writeSettings: [],
    adfAppModelConfiguration: {
        displayName: format(stringResources.ModelName_DisplayTextPreviewTemplate, 'Kafka'),
        linkedService: {
            properties: [
                'kafkaBroker',
                'username',
                'password'
            ],
            uiControls: [
                {
                    bind: 'kafkaBroker',
                    controlType: 'TextBox',
                    displayName: 'Broker',
                    description: 'IP:PORT of Kafka broker'
                },
                {
                    bind: 'username',
                    controlType: 'TextBox',
                    displayName: 'Username',
                    description: 'SASL PLAIN Username'
                },
                {
                    bind: 'password',
                    controlType: 'TextBox',
                    displayName: 'Password',
                    description: 'SASL PLAIN Password'
                }
            ]
        },
        dataflowInlineSource: {
            properties: [
                'topic',
                'schemaRegistry',
                'dataDump',
                'startingOffset',
                'jobDuration'
            ],
            uiControls: [
                {
                    bind: 'topic',
                    controlType: 'TextBox',
                    displayName: 'Topic',
                    description: 'Kafka topic to subscribe'
                },
                {
                    bind: 'schemaRegistry',
                    controlType: 'TextBox',
                    displayName: 'Schema registry',
                    description: 'Confluent schema registry URL to fetch topic schema'
                },
                {
                    bind: 'dataDump',
                    controlType: 'CheckBox',
                    displayName: 'Data dump',
                    description: 'Check if you just want to copy data from source to sink without any transformations'
                },
                {
                    bind: 'startingOffset',
                    controlType: 'DropDown',
                    displayName: 'Starting offset',
                    defaultValue: 'latest',
                    controlSettings: {
                        options: [
                            { label: 'Latest', value: 'latest' },
                            { label: 'Earliest', value: 'earliest' }
                        ]
                    }
                },
                {
                    bind: 'jobDuration',
                    controlType: 'TextBoxNumber',
                    displayName: 'Job duration',
                    description: 'Duration in milliseconds for run the dataflow'
                }
            ],
            itemSettings: {
                dataflowType: 'kafka',
                dataflowUseInlineProjection: true,
                dataflowFormat: 'rest'
            }
        }
    }
};

export default connector;
